export const isLinkFrodor = (href) => /https?:\/\/artists.spotify.com(\/.*)?$/.test(href);
//# sourceMappingURL=isLinkFrodor.js.map